/**
 * @copyright Copyright 2023-2023 Epic Systems Corporation
 * @file Error alert page for Showroom
 * @module Epic.AppOrchard.Showroom.ShowroomErrorAlert
 */

import { Alert, AlertDescription, AlertIcon, AlertTitle } from "@chakra-ui/react";
import React, { FunctionComponent, memo } from "react";

interface IProps {
	errorMessage: string;
	title?: string;
}

export const ShowroomErrorAlert: FunctionComponent<IProps> = memo((props) => {
	const { errorMessage, title } = props;

	return (
		<Alert
			status="error"
			variant="subtle"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			textAlign="center"
			background="none"
		>
			<AlertIcon boxSize="50px" mr={0} />
			<AlertTitle mt={4} mb={1} fontSize="2xl">
				{title ?? "Whoops"}
			</AlertTitle>
			<AlertDescription maxWidth="none" fontSize="xl">
				{errorMessage}
			</AlertDescription>
		</Alert>
	);
});
